import backendRequest from '../../../services/api/backendRequest'
import companyGroupEndpoints from '../api/companyGroupEndpoints'
import companyGroupQueryKeys from './companyGroupQueryKeys'
import { Company } from '../../../types/company/Company'

export type CompanyGroup = {
  subsidiaries: Company[]
  group: Company
}

export const getCompanyGroupOptions = <TData = CompanyGroup>(
  companyId: string,
  select?: (data: CompanyGroup) => TData
) => {
  return {
    queryKey: companyGroupQueryKeys.group({ companyId }),
    queryFn: async () => {
      const response = await backendRequest<CompanyGroup>({
        method: 'GET',
        url: companyGroupEndpoints.group(companyId)
      })
      return response
    },
    enabled: !!companyId,
    gcTime: 15 * 60 * 1000, // 15 minutes
    staleTime: 10 * 60 * 1000, // 10 minutes
    select
  }
}
